import { createAction } from './core';
// PUBLIC API
export const resendEmailVerification = createAction('operations/resend-email-verification', ['User']);
// PUBLIC API
export const runAuthMigration = createAction('operations/run-auth-migration', ['User']);
// PUBLIC API
export const generatePassword = createAction('operations/generate-password', []);
// PUBLIC API
export const updateEmail = createAction('operations/update-email', ['User']);
// PUBLIC API
export const syncGoogleProfile = createAction('operations/sync-google-profile', ['User']);
// PUBLIC API
export const submitColdStartChoices = createAction('operations/submit-cold-start-choices', ['User']);
// PUBLIC API
export const getOnboardingCandidates = createAction('operations/get-onboarding-candidates', ['User']);
// PUBLIC API
export const recordOnboardingChoice = createAction('operations/record-onboarding-choice', ['User']);
// PUBLIC API
export const completeOnboarding = createAction('operations/complete-onboarding', ['User']);
// PUBLIC API
export const getInitialRecipeRecommendations = createAction('operations/get-initial-recipe-recommendations', ['User', 'Recipe']);
// PUBLIC API
export const saveOnboardingRecipes = createAction('operations/save-onboarding-recipes', ['User', 'UserSavedRecipe', 'Recipe']);
// PUBLIC API
export const recordInitialRecipeSelections = createAction('operations/record-initial-recipe-selections', ['User', 'UserEvent']);
// PUBLIC API
export const ensureTasteProfile = createAction('operations/ensure-taste-profile', ['User']);
// PUBLIC API
export const recordSwipeEvent = createAction('operations/record-swipe-event', ['User', 'SwipeEvent', 'Recipe']);
// PUBLIC API
export const getUserVariant = createAction('operations/get-user-variant', ['User']);
// PUBLIC API
export const trackABTestEvent = createAction('operations/track-abtest-event', ['User']);
// PUBLIC API
export const getABTestResults = createAction('operations/get-abtest-results', ['User']);
// PUBLIC API
export const refreshDemoPlan = createAction('operations/refresh-demo-plan', ['User']);
// PUBLIC API
export const downloadPlanPdf = createAction('operations/download-plan-pdf', ['User']);
// PUBLIC API
export const personalizeAndAddRecipeToMealPlan = createAction('operations/personalize-and-add-recipe-to-meal-plan', ['User', 'MealPlan', 'Recipe', 'RecipeIngredient', 'RecipeStep', 'UserRecipe']);
// PUBLIC API
export const previewPersonalizedRecipe = createAction('operations/preview-personalized-recipe', ['User', 'Recipe', 'RecipeIngredient', 'RecipeStep', 'UserProfile']);
// PUBLIC API
export const semanticRecipeSearch = createAction('operations/semantic-recipe-search', ['User', 'Recipe', 'UserTasteProfile']);
// PUBLIC API
export const findSimilarRecipes = createAction('operations/find-similar-recipes', ['User', 'Recipe']);
// PUBLIC API
export const rebuildUserTasteProfile = createAction('operations/rebuild-user-taste-profile', ['User', 'UserTasteProfile', 'UserSavedRecipe', 'CookingSession', 'SwipePattern']);
// PUBLIC API
export const generateSeedEmbedding = createAction('operations/generate-seed-embedding', ['User', 'UserProfile', 'UserTasteProfile']);
// PUBLIC API
export const createHousehold = createAction('operations/create-household', ['User', 'Household', 'HouseholdMember']);
// PUBLIC API
export const addEquipment = createAction('operations/add-equipment', ['User', 'KitchenEquipment']);
// PUBLIC API
export const updateEquipment = createAction('operations/update-equipment', ['User', 'KitchenEquipment']);
// PUBLIC API
export const removeEquipment = createAction('operations/remove-equipment', ['User', 'KitchenEquipment']);
// PUBLIC API
export const inviteHouseholdMember = createAction('operations/invite-household-member', ['User', 'Household', 'HouseholdMember']);
// PUBLIC API
export const acceptHouseholdInvitation = createAction('operations/accept-household-invitation', ['User', 'Household', 'HouseholdMember']);
// PUBLIC API
export const accept = createAction('operations/accept', ['User', 'Household', 'HouseholdMember']);
// PUBLIC API
export const updateHouseholdMemberRole = createAction('operations/update-household-member-role', ['User', 'Household', 'HouseholdMember']);
// PUBLIC API
export const removeHouseholdMember = createAction('operations/remove-household-member', ['User', 'Household', 'HouseholdMember']);
// PUBLIC API
export const createTask = createAction('operations/create-task', ['Task']);
// PUBLIC API
export const updateTaskStatus = createAction('operations/update-task-status', ['Task']);
// PUBLIC API
export const deleteCompletedTasks = createAction('operations/delete-completed-tasks', ['Task']);
// PUBLIC API
export const createTag = createAction('operations/create-tag', ['Tag']);
// PUBLIC API
export const createUserProfile = createAction('operations/create-user-profile', ['User', 'UserProfile']);
// PUBLIC API
export const updateUserProfile = createAction('operations/update-user-profile', ['User', 'UserProfile']);
// PUBLIC API
export const getProfileProgress = createAction('operations/get-profile-progress', ['User', 'UserProfile']);
// PUBLIC API
export const recordInterestAuthed = createAction('operations/record-interest-authed', ['FeatureInterest']);
// PUBLIC API
export const recordInterestEmail = createAction('operations/record-interest-email', ['FeatureInterest']);
// PUBLIC API
export const generateMealPlan = createAction('operations/generate-meal-plan', ['User', 'MealPlan', 'UserProfile']);
// PUBLIC API
export const regenerateMealPlan = createAction('operations/regenerate-meal-plan', ['User', 'MealPlan', 'UserProfile']);
// PUBLIC API
export const emailWeeklyMealPlan = createAction('operations/email-weekly-meal-plan', ['User', 'MealPlan']);
// PUBLIC API
export const listMealPlans = createAction('operations/list-meal-plans', ['User', 'MealPlan']);
// PUBLIC API
export const updateTasteProfile = createAction('operations/update-taste-profile', ['User', 'UserProfile']);
// PUBLIC API
export const recordUserInteraction = createAction('operations/record-user-interaction', ['User', 'UserProfile', 'SwipePattern', 'UserEvent', 'PersonalizationInsight']);
// PUBLIC API
export const applyAIProfileSuggestions = createAction('operations/apply-aiprofile-suggestions', ['User', 'UserProfile', 'PersonalizationInsight', 'UserEvent']);
// PUBLIC API
export const cleanupOldPreferences = createAction('operations/cleanup-old-preferences', ['User', 'SwipePattern', 'PersonalizationInsight', 'UserEvent']);
// PUBLIC API
export const getAILearningStats = createAction('operations/get-ailearning-stats', ['User', 'SwipePattern', 'PersonalizationInsight', 'UserEvent']);
// PUBLIC API
export const abTestRecommendations = createAction('operations/ab-test-recommendations', ['User', 'UserProfile', 'UserEvent']);
// PUBLIC API
export const getAISystemDashboard = createAction('operations/get-aisystem-dashboard', ['User', 'SwipePattern', 'PersonalizationInsight', 'UserEvent']);
// PUBLIC API
export const runDbBackupOnce = createAction('operations/run-db-backup-once', []);
// PUBLIC API
export const getQdrantStats = createAction('operations/get-qdrant-stats', []);
// PUBLIC API
export const optimizeQdrant = createAction('operations/optimize-qdrant', []);
// PUBLIC API
export const updateFeatureFlags = createAction('operations/update-feature-flags', ['FeatureFlag']);
// PUBLIC API
export const bulkUpdateIngredientUnits = createAction('operations/bulk-update-ingredient-units', ['RecipeIngredient']);
// PUBLIC API
export const createCheckoutSession = createAction('operations/create-checkout-session', ['User', 'Subscription']);
// PUBLIC API
export const createTierCheckout = createAction('operations/create-tier-checkout', ['User', 'Subscription']);
// PUBLIC API
export const createStripePortalSession = createAction('operations/create-stripe-portal-session', ['User', 'Subscription']);
// PUBLIC API
export const createLemonSqueezyPortalSession = createAction('operations/create-lemon-squeezy-portal-session', ['User', 'Subscription']);
// PUBLIC API
export const createPause = createAction('operations/create-pause', ['User', 'SubscriptionPause', 'RetentionOffer']);
// PUBLIC API
export const applyDiscount50for3m = createAction('operations/apply-discount50for3m', ['User', 'RetentionOffer']);
// PUBLIC API
export const grantFreeMonth = createAction('operations/grant-free-month', ['User', 'RetentionOffer']);
// PUBLIC API
export const submitSurvey = createAction('operations/submit-survey', ['User', 'CancellationSurvey']);
// PUBLIC API
export const finalizeCancellation = createAction('operations/finalize-cancellation', ['User', 'Subscription']);
// PUBLIC API
export const reorderPlanDays = createAction('operations/reorder-plan-days', ['User', 'MealPlan']);
// PUBLIC API
export const generateMealPlanV3 = createAction('operations/generate-meal-plan-v3', ['User', 'MealPlan', 'UserProfile', 'UsageTracking']);
// PUBLIC API
export const startCookingSession = createAction('operations/start-cooking-session', ['User']);
// PUBLIC API
export const patchCookingProgress = createAction('operations/patch-cooking-progress', ['User']);
// PUBLIC API
export const completeCookingSession = createAction('operations/complete-cooking-session', ['User']);
// PUBLIC API
export const upsertMealPlanEntries = createAction('operations/upsert-meal-plan-entries', ['User', 'MealPlan', 'MealPlanEntry']);
// PUBLIC API
export const addRecipeToMealPlan = createAction('operations/add-recipe-to-meal-plan', ['User', 'MealPlan', 'MealPlanEntry', 'Recipe']);
// PUBLIC API
export const removeRecipeFromMealPlan = createAction('operations/remove-recipe-from-meal-plan', ['User', 'MealPlan', 'MealPlanEntry']);
// PUBLIC API
export const updateMealPlanSlot = createAction('operations/update-meal-plan-slot', ['User', 'MealPlan', 'MealPlanEntry']);
// PUBLIC API
export const saveExternalRecipe = createAction('operations/save-external-recipe', ['User', 'Recipe', 'RecipeIngredient', 'Ingredient', 'RecipeStep']);
// PUBLIC API
export const ensureExternalRecipe = createAction('operations/ensure-external-recipe', ['User', 'Recipe']);
// PUBLIC API
export const scaleRecipe = createAction('operations/scale-recipe', ['User', 'Recipe', 'RecipeIngredient', 'Ingredient', 'UserRecipe']);
// PUBLIC API
export const duplicateRecipe = createAction('operations/duplicate-recipe', ['User', 'Recipe', 'RecipeIngredient', 'Ingredient', 'RecipeStep']);
// PUBLIC API
export const deleteCustomRecipe = createAction('operations/delete-custom-recipe', ['User', 'Recipe', 'RecipeIngredient', 'RecipeStep', 'MealPlan', 'MealPlanEntry']);
// PUBLIC API
export const savePersonalizedRecipe = createAction('operations/save-personalized-recipe', ['User', 'Recipe', 'RecipeIngredient', 'Ingredient', 'RecipeStep']);
// PUBLIC API
export const shareRecipe = createAction('operations/share-recipe', ['User', 'Recipe']);
// PUBLIC API
export const cloneSharedRecipe = createAction('operations/clone-shared-recipe', ['User', 'Recipe', 'RecipeIngredient', 'Ingredient', 'RecipeStep', 'UserSavedRecipe', 'MealPlan']);
// PUBLIC API
export const generateShoppingList = createAction('operations/generate-shopping-list', ['User', 'ShoppingList', 'ShoppingListItem']);
// PUBLIC API
export const updateShoppingListItem = createAction('operations/update-shopping-list-item', ['User', 'ShoppingList', 'ShoppingListItem']);
// PUBLIC API
export const generateAIRecommendations = createAction('operations/generate-airecommendations', ['User']);
// PUBLIC API
export const chatWithAI = createAction('operations/chat-with-ai', ['User']);
// PUBLIC API
export const runMealPlanDiagnostics = createAction('operations/run-meal-plan-diagnostics', ['User', 'UserProfile', 'MealPlan']);
// PUBLIC API
export const exportAnalyticsCSV = createAction('operations/export-analytics-csv', ['User', 'Subscription', 'Payment', 'UserEvent', 'AiEvent', 'MetricDaily']);
// PUBLIC API
export const exportAnalyticsJSON = createAction('operations/export-analytics-json', ['User', 'Subscription', 'Payment', 'UserEvent', 'AiEvent', 'MetricDaily']);
// PUBLIC API
export const recordExport = createAction('operations/record-export', ['User', 'ExportHistory']);
// PUBLIC API
export const incrementDownloadCount = createAction('operations/increment-download-count', ['User', 'ExportHistory']);
// PUBLIC API
export const runWeeklyJobOnce = createAction('operations/run-weekly-job-once', ['User', 'MealPlan', 'UserProfile', 'JobLog']);
// PUBLIC API
export const runSnapshotMetricsOnce = createAction('operations/run-snapshot-metrics-once', ['User', 'Subscription', 'Payment', 'MetricDaily', 'AiEvent', 'UserEvent']);
// PUBLIC API
export const runEmailTouchpointsOnce = createAction('operations/run-email-touchpoints-once', ['User', 'Subscription']);
// PUBLIC API
export const runCleanupTokensOnce = createAction('operations/run-cleanup-tokens-once', []);
// PUBLIC API
export const updateNavPreferences = createAction('operations/update-nav-preferences', ['User', 'UserNavigationPreference']);
// PUBLIC API
export const updateUnitPreference = createAction('operations/update-unit-preference', ['User', 'UserProfile']);
// PUBLIC API
export const toggleFavorite = createAction('operations/toggle-favorite', ['UserSavedRecipe', 'Recipe']);
// PUBLIC API
export const approveScrapedRecipe = createAction('operations/approve-scraped-recipe', ['ScrapedRecipe', 'Recipe', 'User']);
// PUBLIC API
export const updateScrapedRecipe = createAction('operations/update-scraped-recipe', ['ScrapedRecipe', 'User']);
// PUBLIC API
export const rejectScrapedRecipe = createAction('operations/reject-scraped-recipe', ['ScrapedRecipe', 'User']);
// PUBLIC API
export const flagScrapedRecipe = createAction('operations/flag-scraped-recipe', ['ScrapedRecipe', 'User']);
// PUBLIC API
export const getRecipeCostQuote = createAction('operations/get-recipe-cost-quote', ['User', 'Recipe', 'RecipeIngredient', 'Ingredient', 'IngredientPrice']);
// PUBLIC API
export const getAdHocRecipeCostQuote = createAction('operations/get-ad-hoc-recipe-cost-quote', ['User']);
// PUBLIC API
export const getEmbeddingStats = createAction('operations/get-embedding-stats', ['User', 'Recipe']);
// PUBLIC API
export const triggerEmbeddingWarmup = createAction('operations/trigger-embedding-warmup', ['User', 'Recipe']);
// PUBLIC API
export const resetUserUsage = createAction('operations/reset-user-usage', ['User', 'UsageTracking', 'AdminAction']);
// PUBLIC API
export const searchUsers = createAction('operations/search-users', ['User', 'UsageTracking']);
// PUBLIC API
export const submitBetaWaitlist = createAction('operations/submit-beta-waitlist', ['BetaWaitlist']);
// PUBLIC API
export const approveBetaWaitlistEntry = createAction('operations/approve-beta-waitlist-entry', ['BetaWaitlist', 'User']);
// PUBLIC API
export const markBetaWaitlistAsPaid = createAction('operations/mark-beta-waitlist-as-paid', ['BetaWaitlist', 'User']);
// PUBLIC API
export const rejectBetaWaitlistEntry = createAction('operations/reject-beta-waitlist-entry', ['BetaWaitlist', 'User']);
//# sourceMappingURL=index.js.map